const ProjectType = {
    LIBRARY: 0,
    STANDARD: 1,
    TEMPLATE: 2
};

const ProjectPrivacyLevel = {
    PUBLIC: 0,
    RESTRICTED: 1,
    PRIVATE: 2,
    LIBRARY: 3
};

module.exports = {
    ProjectType,
    ProjectPrivacyLevel
};
